import { DialogTitle, styled } from '@mui/material'

import { hubloTheme } from '@front/theme'

export const StyledDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    padding: ${hubloTheme.spacing(2, 3)};
  }
`
